import React from "react";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import "./hero.css";

const Hero = ({ onBook }) => {
  const { lang } = useLanguage();
  const t = content[lang].hero;
  const stats = content[lang].stats;

  return (
    <section id="inicio" className="narwhal-hero" data-testid="hero-section" aria-labelledby="hero-title">
      <div className="hero-stage" data-testid="hero-stage">
        <picture className="hero-artwork" data-testid="hero-artwork">
          <img
            src="/dashboard-narwhal-1536.webp"
            srcSet="/dashboard-narwhal-960.webp 960w, /dashboard-narwhal-1536.webp 1536w"
            sizes="(max-width: 768px) 92vw, 52vw"
            alt={t.imageAlt}
            width="1536"
            height="1024"
            fetchPriority="high"
            decoding="async"
            data-testid="hero-dashboard-image"
          />
        </picture>
        <div className="hero-copy" data-testid="hero-copy">
          <p className="hero-kicker" data-testid="hero-kicker"><span aria-hidden="true" />{t.kicker}</p>
          <h1 id="hero-title" className="hero-title" data-testid="hero-title">
            <span className="hero-title-top" data-testid="hero-title-top">{t.titleTop}</span>{" "}
            <span className="hero-title-accent" data-testid="hero-title-accent">
              {t.titleAccentLines.map((line, index) => <React.Fragment key={line}>{index > 0 && <><br />{" "}</>}{line}</React.Fragment>)}
            </span>
          </h1>
          <p className="hero-description" data-testid="hero-description">{t.sub}</p>
          <button onClick={onBook} className="hero-cta" data-testid="hero-book-call-button">
            {t.cta}<ArrowRight aria-hidden="true" />
          </button>
          <dl className="hero-stats" data-testid="hero-stats">
            {stats.map((stat, index) => (
              <div key={index} className="hero-stat" data-testid={`hero-stat-${index}`}>
                <dt data-testid={`hero-stat-label-${index}`}>{stat.label}</dt>
                <dd data-testid={`hero-stat-value-${index}`}>{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>
        <p className="hero-tagline" data-testid="hero-tagline">{t.tagline}</p>
      </div>
    </section>
  );
};

export default Hero;
